import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";

const getAuthHeaders = () => {
  const token = localStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const useDealDocuments = () => {
  const [documents, setDocuments] = useState([]);
  const [loadingDocs, setLoadingDocs] = useState(true);
  const [docsError, setDocsError] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/settings/deal-documents`, {
          params: { active: true },
          withCredentials: true,
          headers: getAuthHeaders(),
        });
        setDocuments(res.data.deal_documents || []);
      } catch (err) {
        setDocsError(err);
        setDocuments([]);
      } finally {
        setLoadingDocs(false);
      }
    };
    fetch();
  }, []);

  return { documents, loadingDocs, docsError };
};

export default useDealDocuments;
